import Box from '@mui/material/Box'
import {
  rewardsTabBarSx,
  rewardsTabButtonActiveSx,
  rewardsTabButtonBaseSx,
} from '../styles/rewardsPageStyles'

export type RewardsTab = 'available' | 'claimed'

interface Props {
  readonly activeTab: RewardsTab
  readonly onTabChange: (tab: RewardsTab) => void
}

export function RewardsTabBar({ activeTab, onTabChange }: Props) {
  return (
    <Box sx={rewardsTabBarSx} role="tablist" aria-label="Rewards tabs" data-testid="rewards-tabs">
      <Box
        component="button"
        type="button"
        role="tab"
        aria-selected={activeTab === 'available'}
        id="rewards-tab-available"
        data-testid="rewards-tab-available"
        onClick={() => onTabChange('available')}
        sx={activeTab === 'available' ? rewardsTabButtonActiveSx : rewardsTabButtonBaseSx}
      >
        Available
      </Box>
      <Box
        component="button"
        type="button"
        role="tab"
        aria-selected={activeTab === 'claimed'}
        id="rewards-tab-claimed"
        data-testid="rewards-tab-claimed"
        onClick={() => onTabChange('claimed')}
        sx={activeTab === 'claimed' ? rewardsTabButtonActiveSx : rewardsTabButtonBaseSx}
      >
        Claimed
      </Box>
    </Box>
  )
}
